import React, { useContext, useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Heading,
  Alert,
  AlertIcon,
  VStack,
} from '@chakra-ui/react';
import UserContext from '../../../context/userContext';
import CustomInput from '../../Common/Input';
import {
  validateEmail,
  validatePhoneNumber,
  validateLastName,
  validateName,
} from '../validaciones';
import { actualizarPostventa } from '../../../services/Admin/actualizarPostventa';
import { useTranslation } from 'react-i18next';

export default function EditarPostVenta({
  postVenta,
  isOpen,
  onClose,
  loadPostventas,
}) {
  const { t } = useTranslation();
  const { user } = useContext(UserContext);
  const [formData, setFormData] = useState({
    id: postVenta?.id ?? '',
    correo: postVenta?.correo ?? '',
    nombre: postVenta?.nombre ?? '',
    apellidos: postVenta?.apellidos ?? '',
    numero: postVenta?.numero ?? '',
  });

  //input errors usuario
  const [inputErrors, setInputErrors] = useState({
    correo: '',
    nombre: '',
    apellidos: '',
    numero: '',
  });

  //errores del back end como correo repetido
  const [errorMsg, setErrorMsg] = useState({ error: false, msg: '' });

  useEffect(() => {
    setFormData({
      id: postVenta?.id ?? '',
      correo: postVenta?.correo ?? '',
      nombre: postVenta?.nombre ?? '',
      apellidos: postVenta?.apellidos ?? '',
      numero: postVenta?.numero ?? '',
    });
    setInputErrors({
      correo: '',
      nombre: '',
      apellidos: '',
      numero: '',
    });
    setErrorMsg({ error: false, msg: '' });
  }, [
    isOpen,
    isOpen,
    postVenta?.apellidos,
    postVenta?.correo,
    postVenta?.id,
    postVenta?.nombre,
    postVenta?.numero,
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrorMsg({ error: false, msg: '' });
    setInputErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
  };

  const validateForm = () => {
    const phoneNumberValidation = validatePhoneNumber(formData.numero);
    const emailValidation = validateEmail(formData.correo);
    const nameValidation = validateName(formData.nombre);
    const lastnameValidation = validateLastName(formData.apellidos);

    const errors = {
      correo: emailValidation.error ? emailValidation.msg : '',
      nombre: nameValidation.error ? nameValidation.msg : '',
      apellidos: lastnameValidation.error ? lastnameValidation.msg : '',
      numero: phoneNumberValidation.error ? phoneNumberValidation.msg : '',
    };

    setInputErrors(errors);
    return Object.values(errors).every((error) => error === '');
  };

  const updatePostventa = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      actualizarPostventa(user.id, formData)
        .then((res) => {
          if (res.status === 200) {
            onClose();
            loadPostventas();
          }
        })
        .catch((err) => {
          //mostrar error estatus 400 y 401 no autorizado o correo repetido
          if (err.response) {
            setErrorMsg({ error: true, msg: err.response.data.error });
          }
        });
    }
  };

  return (
    <Modal
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      size={{
        base: 'md',
        md: 'lg',
        xl: 'xl',
      }}
    >
      <ModalOverlay
        bg="blackAlpha.400"
        backdropFilter="blur(5px)"
      />
      <ModalContent>
        <ModalHeader>
          <Heading
            as="h3"
            size={{
              base: 'md', //cambiar a "xl" si se desea mas grande en dispositivos moviles
              md: 'xl',
              xl: 'xl',
            }}
          >
            {t('EDIT_POSTSELL')}: {postVenta.nombre}
          </Heading>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={2}>
            <CustomInput
              label={t('EMAIL')}
              type="text"
              name="correo"
              value={formData.correo}
              onChange={handleChange}
              error={inputErrors.correo}
            />

            <CustomInput
              label={t('NAME')}
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              error={inputErrors.nombre}
            />

            <CustomInput
              label={t('LAST_NAME')}
              type="text"
              name="apellidos"
              value={formData.apellidos}
              onChange={handleChange}
              error={inputErrors.apellidos}
            />

            <CustomInput
              label={t('PHONE_NUMBER')}
              type="text"
              name="numero"
              value={formData.numero}
              onChange={handleChange}
              error={inputErrors.numero}
            />
            {errorMsg.error && (
              <Alert status="warning">
                <AlertIcon />
                {errorMsg.msg}
              </Alert>
            )}
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button
            variant="ghost"
            onClick={onClose}
          >
            {
              t('CANCEL')
            }
          </Button>
          <Button
            colorScheme="blue"
            mr={3}
            onClick={updatePostventa}
          >
            {t('UPDATE_DATA')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
